import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  OnInit,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthService } from '@nebalkon-workspace/auth';
import { CABINET_PATHS } from '@nebalkon-workspace/cabinet-core';
import { StaffLeadsStatsService } from '../leads/staff-leads-stats.service';
import { StaffWalletStatsService } from '../wallet/staff-wallet-stats.service';
import {
  staffCabinetMoreMenuItemsForRoles,
  staffCabinetNavLink,
  type StaffCabinetNavItem,
} from './staff-cabinet-nav.util';

@Component({
  selector: 'lib-staff-cabinet-more-menu',
  imports: [RouterLink, TranslatePipe],
  templateUrl: './staff-cabinet-more-menu.component.html',
  styleUrl: './staff-cabinet-more-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StaffCabinetMoreMenuComponent implements OnInit {
  readonly #auth = inject(AuthService);
  readonly #paths = inject(CABINET_PATHS);
  readonly #walletStats = inject(StaffWalletStatsService);
  readonly #leadsStats = inject(StaffLeadsStatsService);

  protected readonly menuItems = computed(() =>
    staffCabinetMoreMenuItemsForRoles(this.#auth.roles()),
  );

  protected readonly debtorsCount = this.#walletStats.debtorsCount;
  protected readonly leadsNewCount = this.#leadsStats.newTotal;

  public ngOnInit(): void {
    this.#walletStats.ensureLoaded();
    this.#leadsStats.ensureLoaded();
  }

  protected navLink(route: string): string {
    return staffCabinetNavLink(route, this.#paths);
  }

  protected itemIcon(item: StaffCabinetNavItem): string {
    return item.icon ?? '/icons/core/gear.svg';
  }

  protected badgeCount(item: StaffCabinetNavItem): number {
    if (item.route === 'leads') {
      return this.leadsNewCount();
    }

    if (item.route === 'users') {
      return this.debtorsCount();
    }

    return 0;
  }

  protected badgeLabelKey(item: StaffCabinetNavItem): string | null {
    if (item.route === 'leads' && this.leadsNewCount() > 0) {
      return 'STAFF.CABINET.NAV.LEADS_NEW_BADGE';
    }

    if (item.route === 'users' && this.debtorsCount() > 0) {
      return 'STAFF.CABINET.NAV.USERS_DEBTORS_BADGE';
    }

    return null;
  }

  protected isDebtorsBadge(item: StaffCabinetNavItem): boolean {
    return item.route === 'users' && this.debtorsCount() > 0;
  }
}
